import React from 'react';
import CampaignHeader from '../../../shared/CampaignHeader';
import CampaignProgressMeta from '../../../shared/CampaignHeader/components/CampaignProgressMeta';

/**
 * CampaignInfo - Campaign title and progress bar for FlowchartView
 * 
 * Uses the shared CampaignHeader component for breadcrumb, icon, and title.
 * Adds the Flow-specific progress bar with shine/glow effects.
 */
const CampaignInfo = ({ 
  sprintName, 
  sprintIcon,
  progress, 
  completedCount, 
  totalCount,
  remainingMinutes = 0,
  remainingMinMinutes,
  missingEstCount = 0,
  remainingBreakdown = [],
  breadcrumbPath = [],
  onNavigateToParent,
  onSelectSprint,
  onRename,
  onIconChange,
}) => {
  return (
    <CampaignHeader
      name={sprintName}
      icon={sprintIcon}
      breadcrumbPath={breadcrumbPath}
      onRename={onRename}
      onIconChange={onIconChange}
      onSelectSprint={onSelectSprint}
      classPrefix="flowchart-hud__campaign"
    >
      {/* Flow-specific progress bar with shine effect */}
      <div className="flowchart-hud__progress-row">
        <div className="flowchart-hud__progress-track">
          <div 
            className="flowchart-hud__progress-fill"
            style={{ width: `${progress}%` }}
          >
            <div className="flowchart-hud__progress-shine" />
          </div>
          <div className="flowchart-hud__progress-glow" style={{ width: `${progress}%` }} />
        </div>
        <span className="flowchart-hud__progress-text">{progress}%</span>
      </div>
      <CampaignProgressMeta
        completedCount={completedCount}
        totalCount={totalCount}
        remainingMinutes={remainingMinutes}
        remainingMinMinutes={remainingMinMinutes}
        missingEstCount={missingEstCount}
        remainingBreakdown={remainingBreakdown}
        className="flowchart-hud__progress-meta"
        countClassName="flowchart-hud__progress-count"
      />
    </CampaignHeader>
  );
};

export default CampaignInfo;
